var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectableWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21925 0.568359H1.12771C0.52048 0.568359 0 1.06715 0 1.69607V8.80929C0 9.41652 0.498793 9.937 1.12771 9.937H8.24093C8.84816 9.937 9.36864 9.43821 9.36864 8.80929V1.67438C9.34696 1.06715 8.84816 0.568359 8.21925 0.568359ZM7.67708 8.22375H1.66987V2.23823H7.67708V8.22375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4751 0.568359H12.3836C11.7763 0.568359 11.2559 1.06715 11.2559 1.69607V8.80929C11.2559 9.41652 11.7547 9.937 12.3836 9.937H19.4968C20.104 9.937 20.6245 9.43821 20.6245 8.80929V1.67438C20.6028 1.06715 20.104 0.568359 19.4751 0.568359Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21925 11.8027H1.12771C0.52048 11.8027 0 12.3015 0 12.9304V20.0437C0 20.6509 0.498793 21.1714 1.12771 21.1714H8.24093C8.84816 21.1714 9.36864 20.6726 9.36864 20.0437V12.9088C9.34696 12.3015 8.84816 11.8027 8.21925 11.8027ZM7.67708 19.4581H1.66987V13.4726H7.67708V19.4581Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4751 11.8037H12.3836C11.7763 11.8037 11.2559 12.3025 11.2559 12.9314V20.0446C11.2559 20.6519 11.7547 21.1724 12.3836 21.1724H19.4968C20.104 21.1724 20.6245 20.6736 20.6245 20.0446V12.9097C20.6028 12.3025 20.104 11.8037 19.4751 11.8037ZM18.9329 19.4591H12.9257V13.4736H18.9329V19.4591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectableWhite);
export default __webpack_public_path__ + "static/media/CollectableWhite.157726f2c78211b61ff2b516eaee3ce7.svg";
export { ForwardRef as ReactComponent };